export default __webpack_public_path__ + "static/media/sports-hover.32dcd214.webp";